import { AddOutlined, DeleteOutline, EditOutlined, ListAlt } from '@mui/icons-material';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { CustomButton, TableData } from '../../../../components';
import { confirmAlert, errorAlert } from '../../../../helpers/alerts';
import { getExceptionsService, removeExceptionService, updateExceptionService } from '../../../../services/roteo/exceptionService';
import { removeException, setActive, setCurrentException, setExceptions, updateException } from '../../../../redux/slices/route/exceptionSlice';
import { Box, Checkbox, FormControlLabel } from '@mui/material';
import Image from 'components/common/Image';
import Images from 'assets/images';
// import { validatePermission } from '../../../../helpers/authentication';

const ExceptionScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { exceptions, active } = useSelector(store => store.exceptions)
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    (async () => {
      try {
        setLoading(true)
        const result = await getExceptionsService(active);
        dispatch(setExceptions(result));
      }
      catch (error) {
        errorAlert(error);
      }
      finally {
        setLoading(false)
      }
    })();
    // eslint-disable-next-line
  }, [active]);

  const handlerClick = () => {
    navigate('crear')
  }

  const handlerEdit = async (row) => {
    dispatch(setCurrentException(row));
    navigate("editar")
  };

  const handlerHistory = async (row) => {
    dispatch(setCurrentException(row));
    navigate("historial")
  };

  const handlerCheck = async (row, currentValue) => {
    try {
      const value = !currentValue;
      await updateExceptionService(row.id, { state: value });
      dispatch(updateException({ id: row.id, data: { state: value } }))
    } catch (error) {
      errorAlert(error);
    }
  }

  const handlerDelete = (row) => {
    confirmAlert({
      title: 'Estas seguro que deseas eliminar esta excepción?',
      // text: `La excepción '${row.name}' será eliminada.`,
      onConfirm: async () => {
        try {
          await removeExceptionService(row.id);
          dispatch(removeException(row.id));
        } catch (error) {
          errorAlert(error);
        }
      },
    });
  };
  return (
    <Box mt={-5}>
      <TableData
        loading={loading}
        dataRows={exceptions}
        headerButtons={[
          <FormControlLabel
            label={'Activas'}
            control={
              <Checkbox
                checked={active}
                checkedIcon={<Image src={Images.icon.check_square} />}
                icon={<Image src={Images.icon.uncheck_square} />}
                onChange={(e) => {
                  dispatch(setActive(e.target.checked))
                }}
              />
            }
          />,
          // validatePermission('permisos', 'permisos', ['agregar']) &&
          <CustomButton
            icon={<AddOutlined />}
            key="addException"
            name={"Excepción"}
            click={handlerClick}
          />,
        ]}
        dataTitle={[
          "Operadora",
          "Región",
          "Segmento",
          "Denominación",
          "Comercio",
          "Proveerdor Primario",
          "Proveerdor Secundario",
          "Monto",
          "Estado",
        ]}
        formatter={({ commerce, denomination, operator, region, segment, primaryProvider, secondaryProvider, currentAmount, amount, state }) => (
          [
            operator?.name,
            // region?.nombre,
            // Recién creada, la excepción llega del alta con las regiones como ids sin poblar
            // hasta que la lista se recarga; sin nombre no hay nada que pintar.
            Array.isArray(region) ? region.map((item) => item?.nombre?.replace('Región ', '')).filter(Boolean).join(', ') : '-',
            segment?.name,
            denomination?.map(({ denomination }) => denomination).join(', '),
            commerce?.username,
            primaryProvider?.name_connector,
            secondaryProvider?.name_connector,
            state ? (amount ? amount + '/' + currentAmount : '-') : amount,
            { type: 'boolean', value: state },
          ])}
        onChecked={handlerCheck}
        actions={[
          // validatePermission('permisos', 'permisos', ['editar']) &&
          {
            label: "Editar",
            icon: <EditOutlined />,
            onClick: (data) => handlerEdit(data)
          },
          // validatePermission('permisos', 'permisos', ['eliminar']) &&
          {
            label: "Eliminar",
            icon: <DeleteOutline />,
            onClick: (data) => handlerDelete(data)
          },
          {
            label: "Historial",
            icon: <ListAlt />,
            onClick: (data) => handlerHistory(data)
          },
        ]}
      />
    </Box>
  )
}

export default ExceptionScreen